export const APP_DOMAIN_REGEX = /(?:(?:app(?:-[a-z]{0,2}\d)?)|(?:local))\.hubspot(?:qa)?\.com/;